
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return require("private-next-pages/contact-us/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-us"])
      });
    }
  